import { Grid, Box, Typography, Rating } from "@mui/material";

import React from "react";
import IRatingList from "../../interface/iRatingList";
import ExpandMoreButton from "../../../../components/inputs/expandMoreButton/expandMoreButton";
import getStarColor from "../../../../functions/getStarColor";

const SearchResultHeader = ({
  rating,
  setRatingList,
}: {
  rating: IRatingList;
  setRatingList: React.Dispatch<React.SetStateAction<IRatingList[]>>;
}): React.JSX.Element => {
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        <Box>
          <Typography variant="caption" color="initial">
            Anrede / Vorname / Nachname
          </Typography>
          <Typography variant="body1" color="initial">
            {`${
              rating.participantSalutation === null
                ? ""
                : rating.participantSalutation
            } ${rating.participantFirstName} ${rating.participantLastName}`}
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        md={3}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        <Box>
          <Typography variant="caption" color="initial">
            Coach
          </Typography>
          <Typography variant="body1" color="initial">
            {`${rating.coachSalutation === "f" ? "Frau" : "Herr"} ${
              rating.coachFirstName
            } ${rating.coachLastName}`}
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        md={2}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="caption" color="initial">
            Erstellt am
          </Typography>
          <Typography variant="body1" color="initial">
            {rating.createdAt.split(" ")[0].split("-").reverse().join(".")}
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        md={2}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="caption" color="initial">
            Bewertung &#8960;
          </Typography>
          <br />
          <Rating
            precision={0.5}
            readOnly
            name="size-large"
            defaultValue={2}
            size="medium"
            value={rating.averageRating}
            sx={{
              color: getStarColor(rating.averageRating),
            }}
          />
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        md={1}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
        }}
      >
        <ExpandMoreButton
          onClick={() =>
            setRatingList((prevState) =>
              prevState.map((r) =>
                r.ratingId === rating.ratingId ? { ...r, expand: !r.expand } : r
              )
            )
          }
          expand={rating.expand}
        />
      </Grid>
    </Grid>
  );
};

export default SearchResultHeader;
